export default __webpack_public_path__ + "static/media/5.830d34d2.jpg";